import { render, staticRenderFns } from "./user_address.vue?vue&type=template&id=447c1ace&scoped=true"
import script from "./user_address.vue?vue&type=script&lang=js"
export * from "./user_address.vue?vue&type=script&lang=js"
import style0 from "./user_address.vue?vue&type=style&index=0&id=447c1ace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447c1ace",
  null
  
)

export default component.exports